export default {
  estaCarregando: false,
  itemSelecionadoID: null,
  itemSelecionado: {
    id: null,
    descricao: null
  }
}
